angular.module( 'acme.view.application.passes.detail.series', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.detail.series.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesDetailSeries = {
        name: 'application.passes.detail.series',
        url: '/series',
        views: {
          "subview-main": {
            controller: 'PassesDetailSeriesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/detail/series/series.tpl.html'
          }
        },
        data: {
          pageTitle: 'View Pass Program Series'
        }
      };

    $stateProvider
      .state(passesDetailSeries);
});
